var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.components),function(name,i){return _c('div',{key:i,class:_vm.compClass},[_c(name,{tag:"component"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }